import React, { useState } from "react";
import { Link } from "react-router-dom";
import FloatingShapes from "@/components/FloatingShapes";
import Nav from "@/components/Nav";
import AuthSeoContent from "@/components/AuthSeoContent";
import api from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch {
      // We intentionally still show success — the endpoint never reveals existence.
      setSent(true);
    } finally { setBusy(false); }
  };

  return (
    <div className="relative min-h-screen grain" data-testid="forgot-password-page">
      <FloatingShapes /><Nav />
      <main className="relative z-10 max-w-md mx-auto px-6 pt-32 pb-20">
        <h1 className="font-display text-5xl text-center">Reset password</h1>
        <p className="font-hand text-stone-500 text-2xl text-center mt-2">we'll email you a link</p>

        {sent ? (
          <div className="sticky-card p-8 mt-10 text-center" data-testid="forgot-password-sent">
            <p className="text-stone-700">
              If <span className="font-medium">{email}</span> has a Loom account, a password-reset link is on its way.
              The link expires in 1 hour.
            </p>
            <p className="text-stone-500 text-sm mt-3">
              Signed up with Google? Just use “Continue with Google” instead.
            </p>
            <Link to="/login" className="btn-primary inline-flex mt-6" data-testid="back-to-login-link">Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="sticky-card p-8 mt-10 space-y-4" data-testid="forgot-password-form">
            <div>
              <label className="text-xs uppercase tracking-[0.18em] text-stone-500">Email</label>
              <input type="email" required value={email} onChange={e=>setEmail(e.target.value)}
                     className="input mt-2" data-testid="forgot-email-input" placeholder="you@page.com"/>
            </div>
            <button type="submit" disabled={busy} className="btn-primary w-full mt-2" data-testid="forgot-submit-button">
              {busy ? "Sending…" : "Send reset link"}
            </button>
            <div className="text-center">
              <Link to="/login" className="text-sm text-stone-500 hover:text-indigo-600 underline-offset-4 hover:underline">
                Back to sign in
              </Link>
            </div>
          </form>
        )}
        <AuthSeoContent variant="forgot" />
      </main>
    </div>
  );
}
